import _ from 'lodash';

/**
 * Map: permission flag → URL prefixes ของเมนูที่อยู่ใน module นั้น
 * ใช้สำหรับ derive permissions จาก system_role.allowed_menus
 */
const PERM_PREFIX_MAP = {
  sale:             ['/sale/'],
  finance_approve:  ['/finance/'],
  hr_management:    ['/humen/'],
  hr_report:        ['/humen/'],
  hr_edit:          ['/humen/'],
  director:         ['/director/'],
  customer:         ['/customer/'],
  project:          ['/project/'],
};

/**
 * คำนวณ permissions จาก system_role.allowed_menus
 * - Role ที่ allowed_menus ว่าง (ไม่จำกัด) → ได้ทุก permission รวม admin
 * - Role ที่มีเมนูใน module X → ได้ permission ของ module X
 * ผลลัพธ์ควร OR กับ DB permissions ไม่ใช่แทนที่
 */
export const derivePermissionsFromRoles = (roles) => {
  const arr = Array.isArray(roles) ? roles : (roles ? [roles] : []);
  if (arr.length === 0) return {};

  // unrestricted role → all permissions
  if (arr.some((r) => !r?.allowed_menus?.length)) {
    return Object.fromEntries(
      [...Object.keys(PERM_PREFIX_MAP), 'admin'].map((k) => [k, true]),
    );
  }

  const allMenus = arr.flatMap((r) => r?.allowed_menus || []);
  const derived = {};
  Object.entries(PERM_PREFIX_MAP).forEach(([perm, prefixes]) => {
    derived[perm] = prefixes.some((prefix) => allMenus.some((h) => h.startsWith(prefix)));
  });
  return derived;
};

const accessRight = (me, moduleName, levelPage = 0) => {
  const lvl = levelPage ?? 0;
  const {
    userData: {
      department: { access = {} } = {},
      role: { level: meLevel } = {},
    } = {},
  } = me || {};

  const userLevel = meLevel != null ? meLevel : 0;
  if (access[`${_.toUpper(moduleName)}`] && userLevel >= lvl) {
    return true;
  }
  return false;
};

/**
 * ถ้ามีการตั้งค่า subMenuAccess[MODULE] อย่างน้อย 1 key จะใช้โหมด whitelist (เฉพาะ href ที่เป็น true)
 * ถ้าไม่มีการตั้งค่าเลยต่อโมดูล = ไม่จำกัดเมนูย่อย (ถ้าเข้าโมดูลได้)
 */
export const subMenuAllowed = (access, moduleName, href) => {
  if (!access || !moduleName || !href) return true;
  const mod = _.toUpper(moduleName);
  const sub = access.subMenuAccess && access.subMenuAccess[mod];
  if (!sub || typeof sub !== 'object' || Object.keys(sub).length === 0) {
    return true;
  }
  return sub[href] !== false;
};

const PROFILE_MENUS = [
  '/profile/timestamp',
  '/profile/ot',
  '/profile/disbursement',
  '/profile/leave',
  '/profile/profile',
];

export const accessRightSubMenu = (me, moduleName, href) => {
  const rawRoles = me?.userData?.system_role;
  const roles = Array.isArray(rawRoles) ? rawRoles : (rawRoles ? [rawRoles] : []);

  // ไม่มี role → เห็นเฉพาะ menu profile
  if (roles.length === 0) return PROFILE_MENUS.includes(href);

  // มี role ใดที่ allowed_menus ว่าง (ไม่จำกัด) → เห็นทุกเมนู
  if (roles.some((r) => !r?.allowed_menus?.length)) return true;

  // รวม allowed_menus จากทุก role
  const combined = new Set(roles.flatMap((r) => r?.allowed_menus || []));
  return combined.has(href);
};

export default accessRight;

/*
การใช้งาน

me คือข้อมูล user ผู้ใช้งานระบบที่ได้จาก server

module คือชื่อ module จาก layout เช่น TMS CRM เป็นต้น

levelPage สำหรับกำหนดระดับการเข้าถึงของ Page นั้น ๆ
ทั้งนี้หากต้องการตรวจสอบการเข้าถึงโมดูลไม่จำเป็นต้องส่งข้อมูลมาแต่ใช้ค่าเริ่มต้นในฟังก์ชันแทน

accessRightSubMenu — ตรวจทั้งโมดูล ระดับบทบาท และสิทธิ์เมนูย่อย (href ตรงกับ Sidebar)
*/
